import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { USER_ROLES, ROUTES } from "../utils/constants";

export function ProtectedRoute({ children, allowedRoles = [] }) {
  const { isAuthenticated, role, initializing } = useSelector((state) => state.auth);
  const location = useLocation();

  if (initializing) {
    return <div style={{ padding: 24, textAlign: "center" }}>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}

export function AdminRoute({ children }) {
  return <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN]}>{children}</ProtectedRoute>;
}

export function EmployeeRoute({ children }) {
  return <ProtectedRoute allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.EMPLOYEE]}>{children}</ProtectedRoute>;
}

export function PublicRoute({ children }) {
  const { isAuthenticated, role, initializing } = useSelector((state) => state.auth);

  if (initializing) {
    return <div style={{ padding: 24, textAlign: "center" }}>Loading...</div>;
  }

  if (isAuthenticated) {
    if (role === USER_ROLES.ADMIN) {
      return <Navigate to={ROUTES.ADMIN_DASHBOARD} replace />;
    }
    return <Navigate to={ROUTES.EMPLOYEE_DASHBOARD} replace />;
  }

  return children;
}
